import stompjs from 'stompjs'

export default class ClientChat {
    constructor(configApp) {
        this.configApp = configApp;
        this.cn = null;
        this.isConnect = false

    }
    open(queue,username,password, cbConnect, cbMessage, cbDisconnect) {
        try
        {
            let url =  this.configApp.chatProtocol + '://' + this.configApp.chatServer  + ":" + this.configApp.chatPort + "/ws";
            let self = this;
            
            this.cn = new stompjs.client(url)
            

            this.cn.debug = function(str) {
                // append the debug log to a #debug div
                console.log("debug",str)
            };
            this.cn.onDisconnect = function() {
                console.log("onDisconnect")
                cbConnect(false)
            };
            this.onWebSocketClose =  function() {
                console.log("onWebSocketClose")
                cbConnect(false)
            };
            this.cn.connect(username ,password, function(frame) {
                self.isConnect = true;
                self.cn.debug("connected to Stomp ");
                self.cn.debug(frame);

                let destination = self.configApp.chatQueue + queue
                self.cn.subscribe(destination, function(message) {
                    cbMessage(message)
                });

                cbConnect(true)
              }, function(error) {
                console.log("Error Connect")
                self.cn.debug(error);
                cbDisconnect();
              });
        }
        catch(ex)
        {
            console.error("open->catch",ex);            
            cbConnect(false)
        }  
    }
    sendMessage(msg) {
        if (this.cn != null)
        {
            this.cn.send(this.configApp.chatMainQueue,{persistent: true},JSON.stringify(msg))
            
        } else {
            //console.log("CLIENT NULL")
        }
    }
 }